import React, { useEffect, useState } from "react";
import axios from "api/baseurl";
import { fetchSecretKey } from "encryptionAndDecryption/secretKeyDecryption";
import { decryptBody } from "encryptionAndDecryption/bodyDecryption";
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Card, Tabs, Tab, MenuItem, TextField, Button, Box, Typography, Pagination,
  Modal, IconButton
} from "@mui/material";
import { BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid, ResponsiveContainer, Cell } from "recharts";


import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { keyframes } from "@mui/system";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

import MDInput from "components/MDInput";

import { toast } from "react-toastify";

function AdminDasboard() {
      const loginData = JSON.parse(localStorage.getItem("loginData"));
  const userid = loginData?.userid;
  const [deviceDetails, setDeviceDetails] = useState(null);
  const [monitoring, setMonitoring] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedComponentId, setSelectedComponentId] = useState("");
  const [fromTime, setFromTime] = useState("");
  const [toTime, setToTime] = useState("");
  const [componentOptions, setComponentOptions] = useState([]);
const colorPalette = [
  "#4285F4", // Blue
  "#34A853", // Green
  "#FB8C00", // Orange
  "#9C27B0", // Purple
  "#F44336", // Red
  "#00ACC1", // Cyan
  "#FFEB3B", // Yellow
  "#8D6E63", // Brown
  "#607D8B", // Blue Gray
  "#E91E63", // Pink
];
  const fetchMonitoring = async () => {
    try {
      const secretKey = await fetchSecretKey();
      const token = JSON.parse(localStorage.getItem("loginData"))?.token;
      if (!token) throw new Error("Authentication token not found.");

      const response = await axios.get(`/api/diagnostics/by-logged-in-admin/${userid}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response.status === 200) {
        const decryptedData = decryptBody(response.data, secretKey);
        setMonitoring(decryptedData || []);
      }
    } catch (error) {
      console.error("Error fetching components:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMonitoring();
  }, []);

  const spinAnimation = keyframes`
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  `;
  const dotPositions = [
    { top: "5%", left: "50%" },
    { top: "20%", left: "80%" },
    { top: "50%", left: "95%" },
    { top: "80%", left: "80%" },
    { top: "95%", left: "50%" },
    { top: "80%", left: "20%" },
    { top: "50%", left: "5%" },
    { top: "20%", left: "20%" },
  ];

  const handleSearch = () => {
    // implement filter logic if needed
  };

  // Transform monitoring data to chart-friendly format
  const chartData = monitoring.map((entry) => {
    const data = { createdTime: entry.createdTime };
    entry.metrics.forEach((metric) => {
      data[metric.unit] = parseFloat(metric.value);
    });
    return data;
  });

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {loading && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            zIndex: 9999,
          }}
        >
          <Box
            sx={{
              position: "relative",
              width: 80,
              height: 80,
              animation: `${spinAnimation} 1.5s linear infinite`,
            }}
          >
            {dotPositions.map((pos, index) => (
              <Box
                key={index}
                sx={{
                  width: 8,
                  height: 8,
                  borderRadius: "50%",
                  backgroundColor:"#2e7faeff",
                  position: "absolute",
                  ...pos,
                }}
              />
            ))}
          </Box>
        </Box>
      )}

      <Card sx={{ padding: 4, width: "90%", margin: "auto" }}>
        <MDBox mt={4} display="flex" justifyContent="center">
          <Card sx={{ width: "100%", maxWidth: "1200px", padding: 3 }}>
            {/* <MDBox display="flex" justifyContent="center" mb={3}>
              <MDBox display="flex" gap={3} flexWrap="wrap" justifyContent="center">
                <TextField
                  select
                  label="Component ID"
                  value={selectedComponentId}
                  onChange={(e) => setSelectedComponentId(e.target.value)}
                  sx={{ minWidth: 200 }}
                  size="small"
                  InputProps={{ sx: { height: 45 } }}
                >
                  {componentOptions.length > 0 ? (
                    componentOptions.map((id, index) => (
                      <MenuItem key={index} value={id}>
                        {id}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem disabled>No component IDs</MenuItem>
                  )}
                </TextField>

                <TextField
                  type="datetime-local"
                  label="From Date & Time"
                  InputLabelProps={{ shrink: true }}
                  value={fromTime}
                  onChange={(e) => setFromTime(e.target.value)}
                  size="small"
                />

                <TextField
                  type="datetime-local"
                  label="To Date & Time"
                  InputLabelProps={{ shrink: true }}
                  value={toTime}
                  onChange={(e) => setToTime(e.target.value)}
                  size="small"
                />

                <Button
                  variant="contained"
                  color="success"
                  size="small"
                  onClick={handleSearch}
                  sx={{
                  backgroundColor:"#2e7faeff",
                    padding: "4px 12px",
                    minWidth: "auto",
                    lineHeight: "1.2",
                    alignSelf: "center",
                    height: "32px",
                  }}
                >
                  Search
                </Button>
              </MDBox>
            </MDBox> */}

            {/* Table */}
            {/* <TableContainer>
              <Table>
                <TableHead>
                  <TableRow sx={{                   backgroundColor:"#2e7faeff" }}>
                    <TableCell align="center" sx={{ fontSize: "15px", fontWeight: "bold", color: "white", border: "1px solid #ddd", width: "350px" }}>Component Serial Number</TableCell>
                    <TableCell align="center" sx={{ fontSize: "15px", fontWeight: "bold", color: "white", border: "1px solid #ddd", width: "350px" }}>Created Time</TableCell>
                    <TableCell align="center" sx={{ fontSize: "15px", fontWeight: "bold", color: "white", border: "1px solid #ddd", width: "350px" }}>Value</TableCell>
                    <TableCell align="center" sx={{ fontSize: "15px", fontWeight: "bold", color: "white", border: "1px solid #ddd", width: "350px" }}>Unit</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {monitoring.length > 0 ? (
                    monitoring.map((item, index) => (
                      <React.Fragment key={index}>
                        {item.metrics.map((metric, metricIndex) => (
                          <TableRow key={metricIndex}>
                            <TableCell align="center" sx={{ border: "1px solid #ddd", fontSize: "15px" }}>
                              {item.componentserialnumber}
                            </TableCell>
                            <TableCell align="center" sx={{ border: "1px solid #ddd", fontSize: "15px" }}>
                              {item.createdTime}
                            </TableCell>
                            <TableCell align="center" sx={{ border: "1px solid #ddd", fontSize: "15px" }}>
                              {metric.value}
                            </TableCell>
                            <TableCell align="center" sx={{ border: "1px solid #ddd", fontSize: "15px" }}>
                              {metric.unit}
                            </TableCell>
                          </TableRow>
                        ))}
                      </React.Fragment>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={4} align="center">No data available</TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer> */}

            {/* Graph */}
        <MDBox mt={6} display="flex" flexDirection="column" gap={4}>
  {monitoring.map((device, index) => {
    const chartData = device.metrics.map((metric) => ({
      name: metric.unit,
      value: parseFloat(metric.value),
    }));

    return (
      <Card
        key={index}
        sx={{ padding: 2, backgroundColor: "#f5faff", width: "100%", maxWidth: 1000, mx: "auto" }}
      >
        <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
          Device: {device.devicecode}
        </Typography>
        <Typography variant="caption" color="textSecondary" gutterBottom>
          Serial: {device.componentserialnumber} | Time: {device.createdTime}
        </Typography>

        <ResponsiveContainer width="100%" height={200}>
          <BarChart data={chartData} barSize={30}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" fontSize={12} />
            <YAxis fontSize={12} />
            <Tooltip />
            <Bar dataKey="value" label={{ position: "top", fontSize: 10 }}>
              {chartData.map((entry, idx) => (
                <Cell
                  key={`cell-${idx}`}
                  fill={colorPalette[idx % colorPalette.length]} // cycle through palette
                />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </Card>
    );
  })}
</MDBox>



          </Card>
        </MDBox>
      </Card>
    </DashboardLayout>
  );
}

export default AdminDasboard;
